module.exports = __webpack_public_path__ + "img/1.3c5cb0d4.png";